import { useEffect, useState } from "react";
import main from "../form-state-machine";
import { useParams } from "react-router-dom";

function CatalogPage() {
  const { organization, team, form } = useParams();
  const [state, setView] = useState({ view: "catalog", message: "" });

  useEffect(() => {
    if (state.view === "catalog") {
      main(window.formhero, { organization, team, form }, setView);
    }
  }, [state.view, organization, team, form]); // Runs only when state.view changes

  const handleBackToCatalog = () => {
    setView({ view: "catalog", message: "" }); // Reset state
  };

  return (
    <div style={styles.container}>
      {state.view !== "catalog" && (
        <div style={styles.messageBox}>
          <p style={styles.message}><p dangerouslySetInnerHTML={{ __html: state.message }} />
          </p>
          <a href="#" onClick={handleBackToCatalog} style={styles.link}>
            ⬅ Back to the form
          </a>
        </div>
      )}
    </div>
  );
}

// Inline CSS styles
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f4f4f4",
  },
  messageBox: {
    padding: "20px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    maxWidth: "400px",
  },
  message: {
    fontSize: "18px",
    color: "#333",
    marginBottom: "15px",
  },
  link: {
    textDecoration: "none",
    color: "#007bff",
    fontWeight: "bold",
    cursor: "pointer",
  },
};

export default CatalogPage;
